import _objectSpread2 from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CAMPAIGN_SALES, CAMPAIGN_DECO } from './constants';
export var AlfavoxChat = function AlfavoxChat(communicationFunctions, callbackFunctions) {
  var _this = this;

  _classCallCheck(this, AlfavoxChat);

  _defineProperty(this, "state", {
    functions: {
      availableAgentCount: null,
      getMessages: null,
      sendMessage: null,
      close: null,
      getConversationStatus: null,
      initialize: null
    },
    callback: {
      liveMessages: null
    },
    isConversationStarted: false,
    shouldListenIncoming: true,
    incomingMessageInterval: 10000
  });

  _defineProperty(this, "chatInstance", null);

  _defineProperty(this, "startConversation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var client,
        isDeco,
        disconnectMsg,
        _this$state,
        initialize,
        isConversationStarted,
        conversationId,
        campaign,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'unauthenticated';
            isDeco = _args.length > 1 ? _args[1] : undefined;
            disconnectMsg = _args.length > 2 ? _args[2] : undefined;
            _this$state = _this.state, initialize = _this$state.functions.initialize, isConversationStarted = _this$state.isConversationStarted;
            conversationId = "".concat(client, "-").concat(new Date().getTime().toString(36));
            campaign = isDeco ? CAMPAIGN_DECO : CAMPAIGN_SALES;
            sessionStorage.setItem('liveChatConversationID', conversationId);

            if (!(initialize && !isConversationStarted)) {
              _context.next = 12;
              break;
            }

            _context.next = 10;
            return initialize('New conversation started', campaign, conversationId);

          case 10:
            _this.chatInstance = _context.sent;

            if (_this.chatInstance) {
              _this.sendMessage("Client number: ".concat(client));

              _this.state.isConversationStarted = true;

              _this.startMessageListener(disconnectMsg);
            }

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  _defineProperty(this, "startMessageListener", function (disconnectMsg) {
    var _this$state2 = _this.state,
        incomingMessageInterval = _this$state2.incomingMessageInterval,
        getConversationStatus = _this$state2.functions.getConversationStatus,
        liveMessages = _this$state2.callback.liveMessages;
    var endMessage = [{
      Text: disconnectMsg
    }];
    var incomingIntervalId = setInterval(_this.checkForMessage, incomingMessageInterval);

    if (_this.chatInstance && getConversationStatus) {
      var statusCheck = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var status;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getConversationStatus();

              case 2:
                status = _context2.sent;

                if (status === 'Closed' && liveMessages) {
                  liveMessages(endMessage);
                  clearInterval(incomingIntervalId);
                  clearInterval(statusCheck);
                  _this.state.isConversationStarted = false;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 15000);
    }
  });

  _defineProperty(this, "checkForMessage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _this$state3, getMessages, liveMessages, messages;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _this$state3 = _this.state, getMessages = _this$state3.functions.getMessages, liveMessages = _this$state3.callback.liveMessages;

            if (!(_this.chatInstance && getMessages && liveMessages)) {
              _context3.next = 6;
              break;
            }

            _context3.next = 4;
            return getMessages();

          case 4:
            messages = _context3.sent;

            if (messages) {
              liveMessages(messages);
            }

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));

  _defineProperty(this, "sendMessage", function (message) {
    var sendMessage = _this.state.functions.sendMessage;

    if (_this.chatInstance && sendMessage) {
      sendMessage(message);
    }
  });

  _defineProperty(this, "getConversationStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var getConversationStatus;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            getConversationStatus = _this.state.functions.getConversationStatus;

            if (!(_this.chatInstance && getConversationStatus)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", getConversationStatus());

          case 3:
            return _context4.abrupt("return", false);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })));

  _defineProperty(this, "availableAgentCount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var availableAgentCount;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            availableAgentCount = _this.state.functions.availableAgentCount;

            if (!(_this.chatInstance && availableAgentCount)) {
              _context5.next = 3;
              break;
            }

            return _context5.abrupt("return", availableAgentCount());

          case 3:
            return _context5.abrupt("return", false);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })));

  this.state.functions = _objectSpread2({}, this.state.functions, {}, communicationFunctions);
  this.state.callback = _objectSpread2({}, this.state.callback, {}, callbackFunctions);
};